import { __accessCheck, __privateGet, __privateAdd, __privateSet, __privateMethod, waitForEvent, matchesMediaQuery, Popover, PopIn, debounce, cachedFetch } from "theme";
import { animate } from "vendor";
let GHDInlinePopover = class extends Popover {
	constructor() {
		super();
	}
  
    get shouldLock() {
      return false;
    }
	
    get shouldAppendToBody() {
      return false;
    }
	
    createEnterAnimationControls() {
		return animate(this, { opacity: [0, 1] }, { duration: 0.2 });
    }
	
    createLeaveAnimationControls() {
		return animate(this, { opacity: [1, 0] }, { duration: 0.2 });
    }
};

if (!window.customElements.get("ghd-inline-popover")) {
  window.customElements.define("ghd-inline-popover", GHDInlinePopover);
}

let GHDBuyButtonsB2B = class extends HTMLButtonElement {
	constructor() {
		super(...arguments);
	    this.addEventListener("click", (event) => {
			event.preventDefault();
			document.forms[this.getAttribute("aria-controls")].dispatchEvent(new Event("submit", {
				bubbles: true,
			}));
	    });
	}
};

if (!window.customElements.get("ghd-buy-buttons-b2b")) {
  window.customElements.define("ghd-buy-buttons-b2b", GHDBuyButtonsB2B, { extends: "button" });
}

let _onSubmit_GHDProductFormB2B, onSubmit_fn_GHDProductFormB2B;
let GHDProductFormB2B = class extends HTMLFormElement {
  constructor() {
    super();
    __privateAdd(this, _onSubmit_GHDProductFormB2B);
    this.addEventListener("submit", __privateMethod(this, _onSubmit_GHDProductFormB2B, onSubmit_fn_GHDProductFormB2B));
  }
  connectedCallback() {
    
  }
};
_onSubmit_GHDProductFormB2B = new WeakSet();
onSubmit_fn_GHDProductFormB2B = async function(event) {
  event.preventDefault();
  if (!this.checkValidity()) {
    this.reportValidity();
    return;
  }
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
  const formData = new FormData(this);
  formData.set("sections", sectionsToBundle.join(","));
  const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
    body: formData,
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
      // Needed for Shopify to check inventory
    }
  });

  const responseJson = await response.json();
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
  if (response.ok) {
    if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
      return window.location.href = `${Shopify.routes.root}cart`;
    }
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent["sections"] = responseJson["sections"];
    
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "variant:add",
        onSuccessDo: formData.get("on_success"),
        cart: cartContent
      }
    }));
  } else {
    this.dispatchEvent(new CustomEvent("cart:error", {
      bubbles: true,
      detail: {
        error: responseJson["description"]
      }
    }));
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }
};
if (!window.customElements.get("ghd-product-form-b2b")) {
  window.customElements.define("ghd-product-form-b2b", GHDProductFormB2B, { extends: "form" });
}

import { animate as animate6 } from "vendor";
let GHDPopIn = class extends PopIn {
  get shouldTrapFocus() {
    return true;
  }
};
if (!window.customElements.get("ghd-pop-in")) {
  window.customElements.define("ghd-pop-in", GHDPopIn);
}

var GHDReturnButton = class extends HTMLButtonElement {
  constructor() {
    super();
  }
  connectedCallback() {
	  if (!this.controls) {
	    throw "Return button component requires an aria-controls attribute that refers to the controlled copy field.";
	  }
	  
      let _this = this;
	  
      this.addEventListener("click", (event) => {
		event.preventDefault();
		
		_this.setAttribute('hidden','hidden');
		_this.controls.removeAttribute('hidden');
      });
  }
  
  get controls() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
};
if (!window.customElements.get("ghd-return-button")) {
  window.customElements.define("ghd-return-button", GHDReturnButton, { extends: "button" });
}

let _onSubmit_GHDTeamJoinForm, onSubmit_fn_GHDTeamJoinForm;
let GHDTeamJoinForm = class extends HTMLFormElement {
  constructor() {
    super();
    __privateAdd(this, _onSubmit_GHDTeamJoinForm);
    this.addEventListener("submit", __privateMethod(this, _onSubmit_GHDTeamJoinForm, onSubmit_fn_GHDTeamJoinForm));
  }
  connectedCallback() {
    
  }
  
  get submissionUrl() {
    return this.getAttribute('custom-action');
  }
  
  get submissionApiKey() {
    return this.getAttribute('api-key');
  }
  
  get submissionTeam() {
    return this.querySelector('input[name="team"]').value;
  }
  
  get submissionPassword() {
    return this.querySelector('input[name="password"]').value;
  }
  
  get submissionCustomer() {
    return this.getAttribute('customer')
  }
  
};
_onSubmit_GHDTeamJoinForm = new WeakSet();
onSubmit_fn_GHDTeamJoinForm = async function(event) {
  event.preventDefault();
  if (!this.checkValidity()) {
    this.reportValidity();
    return;
  }
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
  
  const response = await fetch(this.submissionUrl + '?' + new URLSearchParams({
      apikey: this.submissionApiKey,
	  team: encodeURIComponent(this.submissionTeam),
      password: encodeURIComponent(this.submissionPassword),
	  customer: this.submissionCustomer
  }), {
	  method: "GET",
	  headers: {
		  "Origin": window.location.origin
	  }
  });

  const responseText = await response.text();
  
  
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
  if (response.ok && responseText && responseText.length) {
	  this.querySelector('.banner--success').classList.remove('hidden');
      this.querySelector('.banner--error').classList.add('hidden');
  } else {
      this.querySelector('.banner--success').classList.add('hidden');
	  this.querySelector('.banner--error').classList.remove('hidden');
  }
};
if (!window.customElements.get("ghd-team-join-form")) {
  window.customElements.define("ghd-team-join-form", GHDTeamJoinForm, { extends: "form" });
}


// js/common/search/predictive-search.js
var _listenersAbortController2, _fetchAbortController, _searchForm, _queryInput, _onInputChanged2, onInputChanged_fn2, _onFormSubmitted2, onFormSubmitted_fn2, _doPredictiveSearch, doPredictiveSearch_fn, _onSearchCleared, onSearchCleared_fn;
var PredictiveSearchGHD = class extends HTMLElement {
  constructor() {
    super();
    /**
     * Check if the input is not empty, and if so, trigger the predictive search
     */
    __privateAdd(this, _onInputChanged2);
    /**
     * Prevent the form submission if the query is empty
     */
    __privateAdd(this, _onFormSubmitted2);
    /**
     * Do the actual predictive search
     */
    __privateAdd(this, _doPredictiveSearch);
    /**
     * If any search is pending, we abort them, and transition to the idle slot
     */
    __privateAdd(this, _onSearchCleared);
    __privateAdd(this, _listenersAbortController2, void 0);
    __privateAdd(this, _fetchAbortController, void 0);
    __privateAdd(this, _searchForm, void 0);
    __privateAdd(this, _queryInput, void 0);
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(document.createRange().createContextualFragment(`<slot name="results"></slot>`));
  }
  connectedCallback() {
    __privateSet(this, _listenersAbortController2, new AbortController());
    __privateSet(this, _searchForm, document.querySelector(`[aria-owns="${this.id}"]`));
    __privateSet(this, _queryInput, __privateGet(this, _searchForm).elements["q"]);
    __privateGet(this, _searchForm).addEventListener("submit", __privateMethod(this, _onFormSubmitted2, onFormSubmitted_fn2).bind(this), { signal: __privateGet(this, _listenersAbortController2).signal });
    __privateGet(this, _searchForm).addEventListener("reset", __privateMethod(this, _onSearchCleared, onSearchCleared_fn).bind(this), { signal: __privateGet(this, _listenersAbortController2).signal });
    __privateGet(this, _queryInput).addEventListener("input", debounce(__privateMethod(this, _onInputChanged2, onInputChanged_fn2).bind(this), this.autoCompleteDelay, { signal: __privateGet(this, _listenersAbortController2).signal }));
  }
  disconnectedCallback() {
    __privateGet(this, _listenersAbortController2).abort();
  }
  /**
   * Return the delay in ms before we send the autocomplete request. Using a value too low can cause the results to
   * refresh too often, so we recommend to keep the default one
   */
  get autoCompleteDelay() {
    return 280;
  }
  
  get searchVendor() {
	  if (this.getAttribute('search-vendor')) {
		  return '+' + this.getAttribute('search-vendor').replace(' ','+');
	  } else {
		  return '';
	  }
  }

  /**
   * Check if the store supports the predictive API (some languages do not). When not supported, the predictive
   * search is simply disabled and only the standard search is used
   */
  supportsPredictiveApi() {
    return JSON.parse(document.getElementById("shopify-features").innerHTML)["predictiveSearch"];
  }
};
_listenersAbortController2 = new WeakMap();
_fetchAbortController = new WeakMap();
_searchForm = new WeakMap();
_queryInput = new WeakMap();
_onInputChanged2 = new WeakSet();
onInputChanged_fn2 = function() {
  if (__privateGet(this, _queryInput).value === "") {
    return __privateMethod(this, _onSearchCleared, onSearchCleared_fn).call(this);
  }
  __privateGet(this, _fetchAbortController)?.abort();
  __privateSet(this, _fetchAbortController, new AbortController());
  try {
    return __privateMethod(this, _doPredictiveSearch, doPredictiveSearch_fn).call(this);
  } catch (e) {
    if (e.name !== "AbortError") {
      throw e;
    }
  }
};
_onFormSubmitted2 = new WeakSet();
onFormSubmitted_fn2 = function(event) {
  if (__privateGet(this, _queryInput).value === "") {
    return event.preventDefault();
  }
};
_doPredictiveSearch = new WeakSet();
doPredictiveSearch_fn = async function() {
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
  const url = `${window.Shopify.routes.root}search${this.supportsPredictiveApi() ? "/suggest" : ""}`,queryParams = `q=${__privateGet(this, _queryInput).value}${this.searchVendor}&section_id=predictive-search&resources[limit]=10&resources[limit_scope]=each`,tempDoc = new DOMParser().parseFromString(await (await cachedFetch(`${url}?${queryParams}`, { signal: __privateGet(this, _fetchAbortController).signal })).text(), "text/html");
  this.querySelector('[slot="results"]').replaceChildren(...document.importNode(tempDoc.querySelector(".shopify-section"), true).children);
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
};
_onSearchCleared = new WeakSet();
onSearchCleared_fn = function() {
  __privateGet(this, _fetchAbortController)?.abort();
  __privateGet(this, _queryInput).focus();
  this.querySelector('[slot="results"]').innerHTML = "";
};
if (!window.customElements.get("predictive-search-ghd")) {
  window.customElements.define("predictive-search-ghd", PredictiveSearchGHD);
}

document.addEventListener("discount_kit:cart_updated", (event) => {
	document.dispatchEvent(new CustomEvent('cart:refresh', {
		detail: {
			onSuccessDo: 'force_open_drawer'
		}
	}));
});

export {
	GHDInlinePopover,
	PredictiveSearchGHD
};

